import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-auto overflow-scroll w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center flex-col"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2" }, "Cargando...", -1)
const _hoisted_4 = {
  key: 1,
  class: "border-collapse sirit-table w-full"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 2,
  class: "flex justify-end items-center"
}
const _hoisted_7 = { class: "text-md ml-2 mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sirit_icon = _resolveComponent("sirit-icon")!
  const _component_sirit_button_icon = _resolveComponent("sirit-button-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_sirit_icon, {
            model: "refresh-cw",
            rotate: ""
          }),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_4, [
          (_ctx.headers.length > 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, key) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: key,
                    class: _normalizeClass(["font-semibold text-lg", [
                        header.align === 'left' ? 'text-left' : '',
                        header.align === 'center' ? 'text-center' : '',
                        header.align === 'right' ? 'text-right' : '',
                ]])
                  }, _toDisplayString(header.label), 3))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass(["text-md", `hover:bg-${_ctx.colors.primary}-50`])
              }, [
                _renderSlot(_ctx.$slots, "default", { item: row }, () => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (value, key) => {
                    return (_openBlock(), _createElementBlock("td", { key: key }))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ])
        ])),
    (!_ctx.loading && _ctx.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.loadingPage)
            ? (_openBlock(), _createBlock(_component_sirit_icon, {
                key: 0,
                model: "refresh-cw",
                class: "mr-2",
                rotate: ""
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_sirit_button_icon, {
            onOnClick: _ctx.getPreviousPage,
            icon: "chevron-left",
            color: "clean",
            disabled: _ctx.disablePreviousPage
          }, null, 8, ["onOnClick", "disabled"]),
          _createElementVNode("span", _hoisted_7, " Página actual: " + _toDisplayString(_ctx.actualPage) + ", Total: " + _toDisplayString(_ctx.maxPages), 1),
          _createVNode(_component_sirit_button_icon, {
            onOnClick: _ctx.getNextPage,
            icon: "chevron-right",
            color: "clean",
            disabled: _ctx.disableNextPage
          }, null, 8, ["onOnClick", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}